/**
 * ============================================================================
 * CONTACT SERVICE - Frontend
 * ============================================================================
 * Submit contact form to backend.
 */

import api from './api';

/**
 * Submit contact form
 * @param {Object} data - { name, email, subject, category?, message }
 * @returns {Promise<{ success: boolean, message?: string }>}
 */
export const submitContact = async (data) => {
  const response = await api.post('/contact', {
    name: data.name?.trim() || '',
    email: data.email?.trim() || '',
    subject: data.subject?.trim() || '',
    category: data.category || 'general',
    message: data.message?.trim() || '',
  });
  return response.data;
};
